import React from 'react'
import { useNavigate } from 'react-router-dom'

const C = {
  g900:'#0D2218', g800:'#1A3A28', g700:'#235233', g600:'#2D6B42',
  g500:'#3D8A57', g400:'#5AAE73', g300:'#85C99A', g100:'#E8F5EE', g50:'#F2FAF5',
  white:'#FFFFFF', text:'#1A2820', muted:'#5A7065', border:'#C8DDD2',
}

const inp = {
  width:'100%', padding:'.85rem 1.1rem', border:`1px solid ${C.border}`,
  borderRadius:10, fontSize:'.9rem', outline:'none', fontFamily:"'DM Sans',sans-serif",
  color:'#1A2820', background:'white', boxSizing:'border-box', transition:'border-color .2s',
}

export default function Contact() {
  const navigate = useNavigate()
  const [form, setForm] = React.useState({ name:'', email:'', phone:'', subject:'', message:'' })
  const [sent, setSent] = React.useState(false)
  const [focused, setFocused] = React.useState(null)

  const handle = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }))
  const submit = e => {
    e.preventDefault()
    if (!form.name || !form.email) return
    setSent(true)
  }

  return (
    <div style={{ background:'white', minHeight:'100vh' }}>

      {/* ── HERO ── */}
      <div style={{ background:`linear-gradient(145deg,${C.g900},${C.g800},${C.g700})`, padding:'3.4rem 1.3rem 2.2rem', position:'relative', overflow:'hidden' }}>
        <div style={{ position:'absolute', inset:0, backgroundImage:`radial-gradient(circle, rgba(255,255,255,.025) 1px, transparent 1px)`, backgroundSize:'28px 28px', pointerEvents:'none' }} />
        <div style={{ position:'absolute', right:'-5%', top:'-20%', width:500, height:500, borderRadius:'50%', background:`radial-gradient(circle,rgba(93,174,115,.12) 0%,transparent 65%)`, pointerEvents:'none' }} />
        <div style={{ position:'absolute', right:'8%', top:'50%', transform:'translateY(-50%)', width:360, height:360, borderRadius:'50%', border:'1px solid rgba(255,255,255,.06)', pointerEvents:'none' }} />

        <div style={{ maxWidth:1600, margin:'0 auto', position:'relative', zIndex:1 }}>
          <div style={{ display:'inline-flex', alignItems:'center', gap:8, background:'rgba(255,255,255,.08)', border:'1px solid rgba(255,255,255,.15)', borderRadius:999, padding:'.3rem .9rem', marginBottom:'1rem' }}>
            <span style={{ width:6, height:6, borderRadius:'50%', background:C.g300, display:'inline-block' }} />
            <span style={{ fontSize:'.66rem', color:'rgba(255,255,255,.7)', letterSpacing:'.14em', textTransform:'uppercase' }}>Get In Touch</span>
          </div>
          <h1 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'clamp(1.9rem,6vw,3.2rem)', color:'white', lineHeight:1.15, marginBottom:'.8rem' }}>
            We'd love to hear from you
          </h1>
          <p style={{ fontSize:'.88rem', color:'rgba(255,255,255,.65)', maxWidth:480, lineHeight:1.6, fontWeight:300 }}>
            Whether you have a question about a treatment, need help with an order, or just want to say hello — our team is here for you.
          </p>
        </div>
      </div>

      {/* ── QUICK CONTACT CARDS ── */}
      <div style={{ background:C.g50, padding:'2.2rem 1.3rem' }}>
        <div style={{ maxWidth:1600, margin:'0 auto', display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))', gap:'1.25rem' }}>
          {[
            { icon:'📞', title:'Call Us', lines:['Available 7 days a week', '9 AM – 8 PM'], action:'+91 98765 43210' },
            { icon:'✉️', title:'Email Us', lines:['We reply within 24 hours'], action:'care@reviveskin.in' },
            { icon:'🚚', title:'Free Delivery', lines:['Medicines & products', 'shipped across India'], action:'Pan-India shipping' },
          ].map(card => <ContactCard key={card.title} {...card} navigate={navigate} />)}
        </div>
      </div>

      {/* ── MAIN CONTENT ── */}
      <div style={{ maxWidth:900, margin:'0 auto', padding:'2.4rem 1.3rem', display:'grid', gridTemplateColumns:'1fr', gap:'1.5rem', alignItems:'start' }}>

        {/* Form */}
        <div>
          <div style={{ fontSize:'.68rem', letterSpacing:'.18em', textTransform:'uppercase', color:C.g600, marginBottom:'.65rem', display:'flex', alignItems:'center', gap:10 }}>
            <span style={{ display:'inline-block', width:28, height:1.5, background:C.g500 }} />Send a Message
          </div>
          <h2 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'clamp(1.6rem,3vw,2.2rem)', color:C.g900, marginBottom:'.75rem', lineHeight:1.15 }}>How can we help you?</h2>
          <p style={{ fontSize:'.875rem', color:C.muted, marginBottom:'2.5rem', lineHeight:1.75 }}>Fill in the form and our team will get back to you within 24 hours.</p>

          {sent ? (
            <div style={{ background:C.g100, border:`1px solid ${C.g400}`, borderRadius:16, padding:'2.5rem', textAlign:'center' }}>
              <div style={{ fontSize:'2.5rem', marginBottom:'1rem' }}>✅</div>
              <h3 style={{ fontFamily:"'DM Serif Display',serif", fontSize:'1.4rem', color:C.g800, marginBottom:'.5rem' }}>Message Sent!</h3>
              <p style={{ fontSize:'.875rem', color:C.muted, lineHeight:1.7 }}>Thank you for reaching out. We'll get back to you within 24 hours.</p>
              <button onClick={() => setSent(false)} style={{ marginTop:'1.5rem', background:C.g700, color:'white', padding:'.7rem 1.75rem', borderRadius:9, fontSize:'.85rem', fontWeight:600, border:'none', cursor:'pointer', fontFamily:"'DM Sans',sans-serif" }}>Send Another</button>
            </div>
          ) : (
            <form onSubmit={submit} style={{ display:'flex', flexDirection:'column', gap:'1.1rem' }}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1rem' }}>
                <div>
                  <label style={{ fontSize:'.75rem', fontWeight:600, color:C.muted, letterSpacing:'.06em', textTransform:'uppercase', display:'block', marginBottom:'.4rem' }}>Your Name *</label>
                  <input name="name" value={form.name} onChange={handle} placeholder="Priya Sharma" required
                    onFocus={() => setFocused('name')} onBlur={() => setFocused(null)}
                    style={{ ...inp, borderColor: focused==='name' ? C.g500 : C.border }} />
                </div>
                <div>
                  <label style={{ fontSize:'.75rem', fontWeight:600, color:C.muted, letterSpacing:'.06em', textTransform:'uppercase', display:'block', marginBottom:'.4rem' }}>Phone Number</label>
                  <input name="phone" value={form.phone} onChange={handle} placeholder="+91 98765 43210"
                    onFocus={() => setFocused('phone')} onBlur={() => setFocused(null)}
                    style={{ ...inp, borderColor: focused==='phone' ? C.g500 : C.border }} />
                </div>
              </div>
              <div>
                <label style={{ fontSize:'.75rem', fontWeight:600, color:C.muted, letterSpacing:'.06em', textTransform:'uppercase', display:'block', marginBottom:'.4rem' }}>Email Address *</label>
                <input name="email" type="email" value={form.email} onChange={handle} placeholder="priya@example.com" required
                  onFocus={() => setFocused('email')} onBlur={() => setFocused(null)}
                  style={{ ...inp, borderColor: focused==='email' ? C.g500 : C.border }} />
              </div>
              <div>
                <label style={{ fontSize:'.75rem', fontWeight:600, color:C.muted, letterSpacing:'.06em', textTransform:'uppercase', display:'block', marginBottom:'.4rem' }}>Subject</label>
                <select name="subject" value={form.subject} onChange={handle}
                  onFocus={() => setFocused('subject')} onBlur={() => setFocused(null)}
                  style={{ ...inp, borderColor: focused==='subject' ? C.g500 : C.border, cursor:'pointer' }}>
                  <option value="">Select a topic…</option>
                  <option>Product Enquiry</option>
                  <option>Order Support</option>
                  <option>Treatment Question</option>
                  <option>Feedback</option>
                  <option>Other</option>
                </select>
              </div>
              <div>
                <label style={{ fontSize:'.75rem', fontWeight:600, color:C.muted, letterSpacing:'.06em', textTransform:'uppercase', display:'block', marginBottom:'.4rem' }}>Message</label>
                <textarea name="message" value={form.message} onChange={handle} placeholder="Tell us how we can help you…" rows={5}
                  onFocus={() => setFocused('message')} onBlur={() => setFocused(null)}
                  style={{ ...inp, resize:'vertical', borderColor: focused==='message' ? C.g500 : C.border }} />
              </div>
              <button type="submit" style={{ background:C.g700, color:'white', padding:'1rem', borderRadius:10, fontSize:'.9rem', fontWeight:600, border:'none', cursor:'pointer', fontFamily:"'DM Sans',sans-serif", letterSpacing:'.04em', boxShadow:`0 4px 16px rgba(35,82,51,.25)`, transition:'all .2s', marginTop:'.25rem' }}
                onMouseEnter={e => { e.currentTarget.style.background=C.g800; e.currentTarget.style.transform='translateY(-1px)' }}
                onMouseLeave={e => { e.currentTarget.style.background=C.g700; e.currentTarget.style.transform='none' }}>
                Send Message →
              </button>
            </form>
          )}
        </div>

        {/* Right side info */}
        <div style={{ display:'flex', flexDirection:'column', gap:'1.5rem' }}>
          {/* Consultation hours */}
          <div style={{ background:C.g50, border:`1px solid ${C.border}`, borderRadius:20, padding:'2rem' }}>
            <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:'1.5rem' }}>
              <div style={{ width:40, height:40, borderRadius:10, background:C.g100, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.2rem' }}>🕐</div>
              <div style={{ fontFamily:"'DM Serif Display',serif", fontSize:'1.15rem', color:C.g900 }}>Consultation Hours</div>
            </div>
            {[
              { day:'Monday – Sunday', time:'10:00 AM – 6:00 PM', open:true },
            ].map(h => (
              <div key={h.day} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'.75rem 0', borderBottom:`1px solid ${C.border}` }}>
                <span style={{ fontSize:'.875rem', color:C.text, fontWeight:500 }}>{h.day}</span>
                <span style={{ fontSize:'.8rem', color: h.open ? C.g600 : C.muted, fontWeight:500, background: h.open ? C.g100 : '#f5f5f5', padding:'.2rem .75rem', borderRadius:999 }}>{h.time}</span>
              </div>
            ))}
          </div>

        </div>
      </div>

    </div>
  )
}

function ContactCard({ icon, title, lines, action, navigate }) {
  const [hov, setHov] = React.useState(false)
  return (
    <div onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{ background: hov ? `linear-gradient(135deg,${C.g700},${C.g500})` : 'white', border:`1px solid ${hov ? C.g500 : C.border}`, borderRadius:18, padding:'1.75rem', transition:'all .35s', cursor:'default', boxShadow: hov ? '0 12px 36px rgba(45,107,66,.18)' : 'none', transform: hov ? 'translateY(-4px)' : 'none' }}>
      <div style={{ width:48, height:48, borderRadius:12, background: hov ? 'rgba(255,255,255,.15)' : C.g100, display:'flex', alignItems:'center', justifyContent:'center', fontSize:'1.4rem', marginBottom:'1.1rem', transition:'all .35s' }}>{icon}</div>
      <div style={{ fontSize:'.95rem', fontWeight:600, color: hov ? 'white' : C.g800, marginBottom:'.5rem', transition:'color .35s' }}>{title}</div>
      {lines.map((l, i) => <div key={i} style={{ fontSize:'.8rem', color: hov ? 'rgba(255,255,255,.65)' : C.muted, lineHeight:1.6, transition:'color .35s' }}>{l}</div>)}
      <div style={{ marginTop:'.9rem', fontSize:'.8rem', fontWeight:600, color: hov ? C.g300 : C.g600, transition:'color .35s' }}>{action}</div>
    </div>
  )
}
